if (!customElements.get('ingredients-slider')) {
  class IngredientsSlider extends HTMLElement {
    selectors = {
      slider: '.swiper',
    };

    constructor() {
      super();
    }

    connectedCallback() {
      this.elements = {
        slider: this.querySelector(this.selectors.slider),
      };

      const spaceBetween = Number(this.dataset.slides) <= 2 ? 100 : 40;

      this.settings = {
        slidesPerView: Number(this.dataset.slides),
        spaceBetween: spaceBetween,
        navigation: {
          prevEl: this.querySelector('.slider__arrow.arrow-left'),
          nextEl: this.querySelector('.slider__arrow.arrow-right'),
        },
      };

      this.slider = new Swiper(this.elements.slider, this.settings);

      if (Shopify.designMode) {
        this.addEventListener(
          'shopify:block:select',
          this.handleBlockSelect.bind(this),
        );
      }
    }

    /**
     * Handle Shopify admin section block select.
     * @param {Object} e Event
     */
    handleBlockSelect(e) {
      const targetIndex = Number(e.target?.getAttribute('data-slide-index'));

      if (!Number.isNaN(targetIndex)) {
        this.slider.slideTo(targetIndex);
      }
    }
  }
  customElements.define('ingredients-slider', IngredientsSlider);
}
